// Copyright © 2021 Move Closer

import { Component, Prop, Vue } from 'vue-property-decorator'

import { BootstrapIcon } from '../../../../dsl/front'

@Component<ArticleActionItem>({
  name: 'ArticleActionItem',
  components: { BootstrapIcon },

  template: `
    <li>
      <button class="article-actions__list__item" :class="className" :title="title" @click="callback">
        <BootstrapIcon :name="icon" size="medium" />
        {{ displayedLabel }}
      </button>
    </li>
  `
})
export class ArticleActionItem extends Vue {
  @Prop({ type: String, required: true })
  private readonly icon!: string

  @Prop({ type: String, required: true })
  private readonly title!: string

  @Prop({ type: String, required: false })
  private readonly label?: string

  @Prop({ type: String, required: false })
  private readonly className?: string

  @Prop({ type: Function, required: true })
  private readonly callback!: () => void

  public get displayedLabel (): string {
    return this.label || this.title
  }
}

export default ArticleActionItem
